<template>
  <div class="info">
    <div class="info-wrap">
      <div class="info-content clearfix">
        <h4 class="h4-en">RECRUITMENT SERVICE</h4>
        <h3 class="h3">四大招聘服务产品</h3>
        <div class="box1">
          <i class="iconfont icon-bazi"></i>
          <h4>智能猎头</h4>
          <p>为您精准匹配专业猎头</p>
          <p>推荐效率高于传统猎头渠道</p>
          <p>适合猎头职位</p>
        </div>
        <div class="box1">
          <i class="iconfont icon-mianshiyaoqing"></i>
          <h4>智能邀约</h4>
          <p>为普通职位招聘精准匹配新鲜简历</p>
          <p>帮助HR完成对人才的意向邀约</p>
          <p>告别搜索、筛选、意向邀约的低效环节</p>
          <p>节省HR在找人环节中90%的工作时间</p>
        </div>
        <div class="box1">
          <i class="iconfont icon-gongyingshang1"></i>
          <h4>供应商管理</h4>
          <p>提供丰富的供应商资源</p>
          <p>解决线下找不到适合猎头的问题</p>
          <p>并且为您的需要做储备</p>
        </div>
        <div class="box1">
          <i class="iconfont icon-jianli1"></i>
          <h4>定向派单</h4>
          <p>通过大数据为您的存量简历库</p>
          <p>提供多种激活服务，让您第一时间知道</p>
          <p>存量简历库中哪些是可使用的新鲜简历</p>
          <p>降低再次购买简历的成本，为HR降本提效</p>
        </div>
      </div>
    </div>
    <div class="info-wrap bgWhite">
      <div class="info-content clearfix">
        <h4 class="h4-en">RESOURCES AND SERVICES</h4>
        <h3 class="h3">特色资源及服务</h3>
        <div class="box2">
          <div class="left"><img src="../../assets/item-01.png"/></div>
          <div class="right">
            <h4>稳定优质的猎头渠道资源匹配推荐</h4>
            <p>30W家猎企入驻平台</p>
            <p>5年做单数据沉淀</p>
            <p>为您提供精准推荐</p>
          </div>
        </div>
        <div class="box2">
          <div class="left"><img src="../../assets/item-02.png"/></div>
          <div class="right">
            <h4>海量新鲜的人才简历智能邀约</h4>
            <p>找人不再搜搜搜</p>
            <p>精细算法推荐+邀约</p>
            <p>效率提升90%</p>
          </div>
        </div>
        <div class="box2">
          <div class="left"><img src="../../assets/item-03.png"/></div>
          <div class="right">
            <h4>全网职位招聘数据同步</h4>
            <p>猎头渠道、常规渠道、线下渠道</p>
            <p>一键同步职位发布，省事省心</p>
          </div>
        </div>
        <div class="box2">
          <div class="left"><img src="../../assets/item-04.png"/></div>
          <div class="right">
            <h4>动态效能数据统计分析管理</h4>
            <p>招聘数据、HR效率、渠道转化率</p>
            <p>全场景节点统计，来源更完整结果更真实</p>
          </div>
        </div>
      </div>
    </div>
    <div class="app-wrap">
      <div class="app-content clearfix">
        <div class="words-info">
          <p>
            简历可<i class="lt">┏</i><b>批量转发</b><i class="rb">┛</i>到面试官微信<br>
            <i class="lt">┏</i><b>快速响应</b><i class="rb">┛</i>面试官的反馈信息<br>
            所有简历职位操作反馈<i class="lt">┏</i><b>一键搞定</b><i class="rb">┛</i>
          </p>
          <div class="down-btn-wrap">
            <a href="https://itunes.apple.com/cn/app/lie-shang-hr-ban/id956705615?mt=8" target="_blank" class="down-btn ios">iPhone下载</a>
            <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.hunteron.hrmobile" target="_blank" class="down-btn and">Android下载</a>
          </div>
        </div>
        <div class="img"><img src="../../assets/phone.png"/></div>
      </div>
    </div>
    <div class="info-wrap bgWhite">
      <div class="info-content clearfix">
        <h4 class="h4-en">OUR CLIENTS</h4>
        <h3 class="h3">TA们都在猎上网</h3>
        <ul class="brand-list">
          <li><img src="../../assets/logo/logo1.jpg"/></li>
          <li><img src="../../assets/logo/logo2.jpg"/></li>
          <li><img src="../../assets/logo/logo3.jpg"/></li>
          <li><img src="../../assets/logo/logo4.jpg"/></li>
          <li><img src="../../assets/logo/logo5.jpg"/></li>
          <li><img src="../../assets/logo/logo6.jpg"/></li>
          <li class="mr0"><img src="../../assets/logo/logo7.jpg"/></li>
          <li><img src="../../assets/logo/logo8.jpg"/></li>
          <li><img src="../../assets/logo/logo9.jpg"/></li>
          <li><img src="../../assets/logo/logo10.jpg"/></li>
          <li><img src="../../assets/logo/logo12.jpg"/></li>
          <li><img src="../../assets/logo/logo13.jpg"/></li>
          <li><img src="../../assets/logo/logo14.jpg"/></li>
          <li class="mr0"><img src="../../assets/logo/logo15.jpg"/></li>
          <li><img src="../../assets/logo/logo16.jpg"/></li>
          <li><img src="../../assets/logo/logo17.jpg"/></li>
          <li><img src="../../assets/logo/logo18.jpg"/></li>
          <li><img src="../../assets/logo/logo19.jpg"/></li>
          <li><img src="../../assets/logo/logo20.jpg"/></li>
          <li><img src="../../assets/logo/logo21.jpg"/></li>
          <li class="mr0"><img src="../../assets/logo/logo22.jpg"/></li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <p class="copyright">
        增值电信业务经营许可证：<a href="http://www.shca.gov.cn/" target="_blank">沪B2-20150145</a>
        <a href="http://www.miitbeian.gov.cn/" target="_blank">沪ICP备13006480号-2</a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302004261" style="display:inline-block;height:20px;line-height:20px;"> <img src="data:image/png;base64,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" width="20" height="20" style="float:left;border:none;margin-right: 2px;"/>沪公网安备 31011302004261号</a>
        Copyright © 2012-2018
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "info",
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
<style lang="scss" scoped>
.info-wrap {
  width: 100%;
  &.bgWhite {
    background: #fff;
  }
  .info-content {
    width: 1200px;
    padding: 50px 0 0;
    margin: 0 auto;
    .h4-en {
      font-size: 14px;
      color: #2d8cf0;
      text-align: center;
      font-weight: bold;
    }
    .h3 {
      font-size: 36px;
      margin-bottom: 50px;
      text-align: center;
    }
    .box1 {
      width: 280px;
      margin: 0 20px 100px 0;
      height: 287px;
      padding: 20px 0;
      text-align: center;
      background: #fff;
      border-radius: 25px 0 25px 0;
      float: left;
      .iconfont {
        color: #2d8cf0;
        font-size: 50px;
      }
      h4 {
        font-size: 18px;
        font-weight: bold;
        margin: 10px 0 15px;
      }
      p {
        font-size: 14px;
        color: #7c7c7c;
        line-height: 30px;
      }
    }
    .box2 {
      width: 600px;
      margin: 0 0 100px 0;
      float: left;
      .left {
        float: left;
        margin-right: 30px;
        width: 228px;
        height: 176px;
      }
      .right {
        float: left;
        h4 {
          font-size: 18px;
          font-weight: bold;
          margin: 28px 0 10px;
        }
        p {
          font-size: 14px;
          color: #7c7c7c;
          line-height: 30px;
        }
      }
    }
    .brand-list {
      width: 1065px;
      margin: 0 auto 80px;
      overflow: hidden;
      li {
        float: left;
        width: 135px;
        margin: 0 20px 20px 0;
        overflow: hidden;
        &.mr0 {
          margin-right: 0;
        }
      }
    }
  }
}
.app-wrap {
  width: 100%;
  height: 380px;
  background: url("../../assets/phoneBg.jpg") center 0 no-repeat;
  .app-content {
    width: 1200px;
    margin: 0 auto;
    .words-info {
      float: left;
      margin-top: 50px;
      p {
        font-size: 24px;
        line-height: 60px;
        b {
          color: #000;
          font-size: 30px;
          font-weight: normal;
        }
        i {
          display: inline-block;
          font-style: normal;
          font-weight: bold;
          color: #2d8cf0;
          margin: 0 3px;
        }
        .lt {
          margin-top: -10px;
          vertical-align: top;
        }
        .rb {
          margin-bottom: -12px;
          vertical-align: bottom;
        }
      }
      .down-btn-wrap {
        margin: 30px 0;
        .down-btn {
          float: left;
          margin-right: 25px;
          color: #fff;
          font-size: 16px;
          width: 175px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 30px;
          background-color: #2d8cf0;
        }
      }
    }
    .img {
      float: right;
      width: 349px;
      height: 433px;
      margin: -53px 250px 0 0;
    }
  }
}
.footer {
  width: 100%;
  height: 50px;
  .copyright {
    margin: 0 auto;
    width: 1200px;
    font-size: 14px;
    line-height: 50px;
    color: #676782;
    text-align: center;
    a {
      color: #676782;
      margin-right: 15px;
      &:hover {
        color: #676782;
        text-decoration: underline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/info.vue